module.exports = __webpack_public_path__ + "img/404.0d8762d3.png";